import React, { useEffect, useState } from "react";
import "./tablestyle.scss";

import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridSortChangeEvent,
    GridNoRecords
} from "@progress/kendo-react-grid";
import Headline6 from "../../components/headings/Headline6";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { REACT_APP_CANDIDATE_FREELANCER } from '../../utils/common'
import { postAPI } from '../../api/apis'; 

function TimeSheet(Props: any) {

    const [candidateData, setCandidateData] = useState()

    useEffect(() => {
        setCandidateData(Props.candidate_data)
    })

    const name = (props: GridCellProps) => {
        return (
            <td>
                <div className="userInfo">
                    <figure><img src="https://i.pravatar.cc/300"></img></figure>
                    {props.dataItem.name}
                </div>
            </td>
        )
    }

    const checkStatus = (status: string) => {
        switch (status) {
            case '2':
                return {
                    value: 'Pending',
                    class: 'statusMessage Yellow'
                }
            case '3':
                return {
                    value: 'Approved',
                    class: 'statusMessage Green'
                }
            case '4':
                return {
                    value: 'Rejected',
                    class: 'statusMessage Red'
                }
            default:
                return {
                    value: '',
                    class: ''
                }
        }
    }

    const editButton = (props: GridCellProps) => {
        return (
            <td>
                <Link style={{ 'color': 'green' }} to={''}>Edit</Link>
            </td>
        )
    }

    const statusCell = (props: GridCellProps) => {
        return (
            <td>
                <div className={checkStatus(props.dataItem.timesheetStatus).class}>
                    {checkStatus(props.dataItem.timesheetStatus).value}
                </div>
            </td>
        )
    }

    const historyCell = (props: GridCellProps) => {
        return (
            <td>
                <Link to={''} onClick={() => Props.showHistory(props.dataItem)}><Icon icon="bx:history" width="25" style={{ 'color': 'rgba(0, 0, 0, 0.6)' }} ></Icon></Link>
            </td>
        )
    }

    const buttonClick = (data: any) => {
        
        if (data.timesheetStatus === '2') {
            Props.sendReminder(data)
        }
        if (data.timesheetStatus === '3' && data.invoiceSigned === true){
            if(data.invoiceFileName != null){
                downloadHandle(data.invoiceFileName)
            }
        }
        if (data.timesheetStatus === '3' && data.invoiceSigned === false){
            if(data.invoiceFileName != null){
                Props.getSignatureUrl(data)
            }
        }
    }
   

    const  viewSubmittedTimesheet = (props: GridCellProps) => { 
        switch(props.dataItem.timesheetStatus){
            case '3' :
                return (
                    <td>
                        <Link to={'/addTimesheet'} style={{ 'color': '#14A800' }} state={{state: props.dataItem ,   candidate_data: Props.candidate_data}}>  <Icon icon="heroicons-outline:eye" width="25" style={{ 'color': 'rgba(0, 0, 0, 0.6)' }} ></Icon></Link>
                    </td>
                )
            default:
                return (
                    <td>

                    </td>
                )
        }
    }

    const editOrRemind = (props: GridCellProps, candidate_data: any) => {
      
        let activeStatus = props.dataItem.activeStatus
        switch (Props.title) {
            case 'currentTimesheet':
                return (
                    <td>
                        <Link to={'/addTimesheet'} style={{ 'color': '#14A800' }} state={{ state: props.dataItem }}>{activeStatus ? 'Edit' : 'Create New'}</Link>
                    </td>
                )
            case 'timesheetHistory':
                return (
                    <td>
                        {/* props.dataItem.invoiceFileName === null  ? 'Generate Invoice'  */}
                        <Link style={{ 'color': 'green' }} onClick={() => buttonClick(props.dataItem)} to={props.dataItem.timesheetStatus === '4' ? '/addTimesheet' : props.dataItem.timesheetStatus === '3' && props.dataItem.invoiceFileName === null ? '/invoicegenerator' : ''} state={ props.dataItem.timesheetStatus === '4' ? { state: props.dataItem, candidate_data: candidateData } : { timesheetId: props.dataItem.timesheetId, candidateId: props.dataItem.candidateId, candidateJobId: props.dataItem.candidateJobId}}>{props.dataItem.timesheetStatus === '2' ? 'Send Reminder' :  props.dataItem.timesheetStatus === '4' ? 'Edit' :  props.dataItem.invoiceFileName === null  ? '' : props.dataItem.invoiceSigned === false ? 'Sign Invoice' : 'View Invoice' }</Link>
                    </td>
                )
            default:
                return (
                    <td>

                    </td>
                )
        }
    }

    const durtionCell = (props: GridCellProps) => {
        return (
            <td>
                {(new Date(parseInt(props.dataItem.startDate))).toDateString().slice(3) + ' - ' + (new Date(parseInt(props.dataItem.endDate))).toDateString().slice(3)}
            </td>
        )
    }

    const submittedonCell = (props: GridCellProps) => {
        return (
            <td>
                {props.dataItem.submittedOn && new Date(parseInt(props.dataItem.submittedOn)).toDateString().slice(3)}
            </td>
        )
    }
    const downloadHandle = (fileName: any) => {
        let value = {
            "action": "getObject",
            "filename": fileName,
            "bucketName": "ellow-prod-doc-upload//signedInvoices",
        }
        postAPI(REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url', value).then((data) => {
            let signedUrl = data.url;
            fetch(signedUrl).then(response => {
                response.blob().then(blob => {
                    const fileURL = window.URL.createObjectURL(blob);
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = fileName;

                    alink.click();
                })
            })
        });
    }
    const ViewButton = (props: GridCellProps) => {
        if (props.dataItem.invoiceFileName != null) {
            return (
                <td>
                    <p onClick={() => downloadHandle(props.dataItem.invoiceFileName)} style={{ 'color': '#14A800' }} >View Invoice</p>
                </td>
            )
        }
        else {
            return (
                <td>
                    <Link to={'/invoicegenerator'} style={{ 'color': '#14A800' }} state={{ timesheetId: props.dataItem.timesheetId, candidateId: props.dataItem.candidateId }}>Generate Invoice</Link>
                </td>
            )
        }
        // return (
        //     <td>
        //         <Link to={'/addTimesheet'} style={{ 'color': '#14A800' }} state={{ state: props.dataItem, timesheetHistory: true }}>View</Link>
        //     </td>
        // )
    }

    return (
        <>
            {Props.title === 'currentTimesheet' ?
                <div className="dateWrap">
                    <Headline6>Draft</Headline6>
                    <Grid
                        data={Props.data}
                    //   onPageChange={props.pageChange}
                    //   total={props.state.total}
                    //   skip={props.state.skip}
                    //   pageable={props.state.pageable}
                    //   pageSize={props.state.pageSize}
                    //   onItemChange={props.itemChange}
                    //  onRowClick={(e) => rowClick(e)}
                    // data={props.state.items && orderBy(props.state.items, sort)}
                    // onSortChange={(e: GridSortChangeEvent) => {
                    //   setSort(e.sort); props.getTableValues()
                    // }}
                    >
                        <GridNoRecords>
                            <div className="noData">
                                <Icon icon="mdi:smiley-neutral-outline" />
                                No data to display
                            </div>
                        </GridNoRecords>
                        <Column cell={durtionCell} title="Duration" className="noWordWrap" />
                        <Column field="projectName" title="Project Name" />
                        {/* <Column cell={editOrRemind} width="120"/> */}
                        <Column cell={(props: GridCellProps) => editOrRemind(props, candidateData)} />
                    </Grid>
                </div> :
                <div>
                    <Grid
                        data={Props.data}
                    //   onPageChange={props.pageChange}
                    //   total={props.state.total}
                    //   skip={props.state.skip}
                    //   pageable={props.state.pageable}
                    //   pageSize={props.state.pageSize}
                    //   onItemChange={props.itemChange}
                    //  onRowClick={(e) => rowClick(e)}
                    // data={props.state.items && orderBy(props.state.items, sort)}
                    // onSortChange={(e: GridSortChangeEvent) => {
                    //   setSort(e.sort); props.getTableValues()
                    // }}
                    >
                        <GridNoRecords>
                            <div className="noData">
                                <Icon icon="mdi:smiley-neutral-outline" />
                                No data to display
                            </div>
                        </GridNoRecords>
                        <Column cell={durtionCell} title="Duration" className="noWordWrap" />
                        <Column field="projectName" title="Project" className="wordBreak" />
                        <Column field="submittedOn" title="Submitted On" cell={submittedonCell} />
                        <Column field="reportingManagerEmail" title="Submitted To" className="wordBreak" />
                        <Column field="verifiedBy" title="Verified By" className="wordBreak" />
                        <Column field="status" title="Status" cell={statusCell} />
                        <Column cell={historyCell} width="40" />
                        <Column cell={viewSubmittedTimesheet} width="40" />
                        <Column cell={editOrRemind} width="120" />
                        {/* {Props.title === 'timesheetHistory' && <Column cell={ViewButton} width="120" />} */}

                    </Grid>
                </div>
            }


        </>
    );
}

export default TimeSheet;
